import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import RatingStars from './RatingStars';

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

export default function MovieCard({ movie, className = '' }: MovieCardProps) {
  return (
    <Link
      to={`/movies/detail/${movie.id}`}
      className={`group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-foreground-100">
        <img
          src={movie.poster}
          alt={`${movie.title}电影海报`}
          title={`${movie.title} - 剧情介绍与影评`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-black/60 backdrop-blur-sm">
          <span className="text-accent-400 text-sm font-bold tabular-nums">
            {movie.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/70 to-transparent"></div>
        <div className="absolute bottom-2 left-2 flex items-center gap-1.5 flex-wrap">
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="px-2 py-0.5 rounded text-[11px] bg-background-50/85 text-foreground-800"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-0.5 text-xs text-foreground-400 truncate">{movie.enTitle}</p>
        <div className="mt-2 flex items-center justify-between gap-2">
          <RatingStars rating={movie.rating} showValue={false} />
          <span className="text-xs text-foreground-500 tabular-nums">{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}